import '../styles/pages/Quality.css';
import useReveal from '../components/useReveal';

const CERT_CARDS = [
  {
    ribbon: 'Certified',  icon: '🏆',
    title: 'WHO GMP Certification',
    desc: 'Our Bahadurgarh manufacturing facility is WHO Good Manufacturing Practice certified, ensuring all products meet international safety, efficacy, and quality standards required for global markets.',
  },
  {
    ribbon: 'Available',  icon: '📋',
    title: 'Drug Master Files (DMF)',
    desc: 'Drug Master File documentation is available for most products in our portfolio, enabling our clients to support regulatory submissions and market authorization applications worldwide with ease.',
  },
  {
    ribbon: 'Approved',   icon: '🌐',
    title: 'MNC Approvals',
    desc: "Pharmchem's APIs are approved by multiple multinational pharmaceutical companies, a testament to the consistent quality and reliability that global industry leaders demand from their supply chain partners.",
  },
  {
    ribbon: 'Compliant',  icon: '⚗️',
    title: 'Multi-Pharmacopoeia Standards',
    desc: 'All APIs are manufactured and tested in compliance with IP (Indian Pharmacopoeia), BP (British), USP (United States), EP (European), and IH (In-House) standards as applicable.',
  },
  {
    ribbon: 'Controlled', icon: '🔬',
    title: 'Analytical Quality Control',
    desc: 'Every batch undergoes rigorous analytical testing in our fully equipped QC laboratory. Advanced instruments ensure identity, purity, potency, and safety specifications are met before any product release.',
  },
  {
    ribbon: 'Tracked',    icon: '📦',
    title: 'Supply Chain Traceability',
    desc: 'Complete batch traceability from raw material sourcing through manufacturing to final dispatch, ensuring full documentation and the ability to trace and recall any lot if ever necessary.',
  },
];

const STANDARDS = [
  { tag: 'IP',  name: 'Indian Pharmacopoeia' },
  { tag: 'BP',  name: 'British Pharmacopoeia' },
  { tag: 'USP', name: 'United States Pharmacopeia' },
  { tag: 'EP',  name: 'European Pharmacopoeia' },
  { tag: 'IH',  name: 'In-House Standards' },
];

const QC_STEPS = [
  { n: '1', title: 'Raw Material Sourcing',   desc: 'Vetted supplier qualification and incoming material testing' },
  { n: '2', title: 'In-Process Controls',     desc: 'Real-time monitoring at critical manufacturing stages' },
  { n: '3', title: 'Finished Product Testing', desc: 'Full pharmacopoeial analysis before batch release' },
  { n: '4', title: 'Stability Studies',        desc: 'ICH-compliant stability programs to ensure shelf life' },
];

function Quality() {
  useReveal();

  return (
    <>
      {/* Hero */}
      <div className="quality-hero">
        <div className="eyebrow" style={{ color: 'rgba(255,255,255,0.7)' }}>Quality Assurance</div>
        <h1>Quality is Our <em>Hallmark</em></h1>
        <p>
          Every product manufactured, tested, and certified to the highest international
          pharmacopoeial standards — because our clients' patients deserve nothing less.
        </p>
      </div>

      <div className="quality-page">
        <div className="quality-inner">

          {/* Certifications */}
          <div style={{ marginBottom: 56 }} className="reveal">
            <div className="eyebrow">Certifications</div>
            <h2 className="headline">Our <em>Quality Credentials</em></h2>
          </div>

          <div className="cert-cards-grid">
            {CERT_CARDS.map((c, i) => (
              <div className={`cert-card reveal stagger-${(i % 3) + 1}`} key={c.title}>
                <div className="cert-card-ribbon">{c.ribbon}</div>
                <span className="cert-card-icon">{c.icon}</span>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>

          {/* Standards */}
          <div className="pharma-standards reveal">
            <div className="eyebrow">Pharmacopoeia Standards</div>
            <h2 className="headline">Compliant Across <em>All Major Standards</em></h2>
            <div className="standards-grid">
              {STANDARDS.map((s) => (
                <div className="std-card" key={s.tag}>
                  <div className="std-tag">{s.tag}</div>
                  <div className="std-name">{s.name}</div>
                </div>
              ))}
            </div>
          </div>

          {/* QC Process */}
          <div className="qc-process reveal">
            <div className="eyebrow">Our Process</div>
            <h2 className="headline">Quality Control <em>at Every Step</em></h2>
            <div className="qc-steps">
              {QC_STEPS.map((s) => (
                <div className="qc-step" key={s.n}>
                  <div className="qc-step-num">{s.n}</div>
                  <h4>{s.title}</h4>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Quality;
